import React from "react";

export const RankingCard = ({
  rank = 1,
  rankSuffix = "th",
  name = "Jessie Ben",
  metrics = {}
}) => {
  let rankColor = "#6cabf6";
  let icon = "🏅";
  let backgroundColor = "#fff8e1";
  let boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";

  if (rank === 1) {
    rankColor = "#ffc64b";
    icon = "🥇";
    rankSuffix = "st";
    backgroundColor = "#fff4cc";
  } else if (rank === 2) {
    rankColor = "#c0c0c0";
    icon = "🥈";
    rankSuffix = "nd";
    backgroundColor = "#f0f0f0";
  } else if (rank === 3) {
    rankColor = "#cd7f32";
    icon = "🥉";
    rankSuffix = "rd";
    backgroundColor = "#fce9d3";
  } else {
    icon = "🏅";
    rankColor = "#6cabf6";
    backgroundColor = "#eef6ff";
  }

  return (
    <div
      className="d-flex align-items-center justify-content-between px-3 py-3 mb-3"
      style={{
        backgroundColor,
        borderRadius: "12px",
        boxShadow,
        transition: "all 0.3s ease"
      }}
    >
      <div className="d-flex align-items-center mr-4" style={{ fontSize: "2rem", fontWeight: 'bold', color: rankColor }}>
        {icon} {rank}{rankSuffix}
      </div>
      <div className="flex-grow-1">
        <div style={{ fontWeight: 700, fontSize: "1.2rem" }}>{name}</div>
        {
          metrics && Object.keys(metrics).length > 0 && (
            <div className="mt-2">
              {Object.entries(metrics).map(([key, value]) => (
                <div key={key} className="d-flex justify-content-between">
                  <span style={{ fontSize: "0.9rem", color: "#555", marginRight: '4px', textTransform: 'capitalize' }}>{key}:</span>
                  <span style={{ fontSize: "0.9rem", fontWeight: 600 }}>{value}</span>
                </div>
              ))}
            </div>
          )
        }
      </div>
    </div>
  );
};
